<template>
  <div>
    <MainCard v-if="!isLoadingTable">
      <template v-slot:body>
        <DataTablePagination
          :page="page"
          :total-items="totalItems"
          :headers="headers"
          :items="libraries"
          :search="search"
          :total-pages.sync="totalPages"
          :filters.sync="filters"
          :is-loading="isLoadingData"
          title="Perpustakaan"
          subtitle="Halaman untuk menambahkan perpustakaan"
          :filter-return-object="true"
          :noAddButton="true"
          :noSearchInput="true"
          @year-filtered="handleYearFilter"
          @category-filtered="handleCategoryFilter"
          @subcategory-filtered="handleSubcategoryFilter"
          @subsubcategory-filtered="handleSubsubcategoryFilter"
          @subsubsubcategory-filtered="handleSubsubsubcategoryFilter"
          @level-filtered="handleLevelFilter"
          @change-page="paginationHandler"
          @live-search="searchHandler"
          @reset-filter="resetFilter"
        >
        </DataTablePagination>
      </template>
    </MainCard>
    <SkeletonLoaderTable v-else></SkeletonLoaderTable>
  </div>
</template>

<script>
import ConfirmDialog from '@/views/components/ConfirmDialog.vue'
import DataTablePagination from '@/views/components/DataTablePagination.vue'
import FileInput from '@/views/components/FileInput.vue'
import MainCard from '@/views/components/MainCard.vue'
import ModalDialog from '@/views/components/ModalDialog.vue'
import SkeletonLoaderTable from '@/views/components/SkeletonLoaderTable.vue'
import {
  mdiBook,
  mdiBookMusic,
  mdiBookPlay,
  mdiClose,
  mdiCloseCircleOutline,
  mdiImageMultipleOutline,
  mdiMapMarker,
} from '@mdi/js'

export default {
  components: {
    DataTablePagination,
    ModalDialog,
    ConfirmDialog,
    FileInput,
    SkeletonLoaderTable,
    MainCard,
  },
  data() {
    return {
      service: 'library',
      isLoadingTable: true,
      isLoadingData: false,
      isLoadingButton: false,
      isDisabledButton: false,
      modalDialog: false,
      editFormDialog: false,
      confirmDialog: false,
      modalDialogWriterAndPublisher: false,
      dialog: '',
      page: 1,
      totalPages: 0,
      totalItems: 0,
      search: '',
      categories: [],
      subcategories: [],
      subsubcategories: [],
      subsubsubcategories: [],
      subsubsubsubcategories: [],
      writers: [],
      writer: {
        name: '',
      },
      type: '',
      publishers: [],
      publisher: {
        name: '',
      },
      libraries: [],
      levels: [],
      multiCategories: [],
      sub_category: {
        uuid: '',
      },
      sub_sub_category: {
        uuid: '',
      },
      sub_sub_sub_category: {
        uuid: '',
      },
      sub_sub_sub_sub_category: {
        uuid: '',
      },
      tempCategory: [],
      library: {
        uuid: '',
        name: '',
        category: {},
        sub_category: {},
        sub_sub_category: {},
        level: {
          uuid: '',
        },
        publisher: {
          uuid: '',
        },
        writer: {
          uuid: null,
        },
        description: '',
        year: '',
        video: '',
        audio: '',
        ebook: '',
        thumbnail: null,
      },
      types: [
        {
          index: 1,
          icon: mdiBookPlay,
          title: 'Video Book',
          value: 'video',
        },
        {
          index: 2,
          icon: mdiBookMusic,
          title: 'Audio Book',
          value: 'audio',
        },
        {
          index: 3,
          icon: mdiBook,
          title: 'E Book',
          value: 'ebook',
        },
      ],
      radioType: '',
      numberChapter: 0,
      chapters: [],
      chapterContent: [],
      chapter_name: [],
      chapter_description: [],
      chapter_content: [],
      icons: {
        mdiMapMarker,
        mdiImageMultipleOutline,
        mdiClose,
        mdiCloseCircleOutline,
      },
      headers: [
        { text: 'No', value: 'index' },

        { text: 'Judul Buku', value: 'name' },
        { text: 'Kategori', value: 'categoryList' },
        { text: 'Sub Kategori', value: 'subcategoryList' },
        { text: 'Sub Kategori', value: 'subsubcategoryList' },
        { text: 'Sub Kategori', value: 'subsubsubcategoryList' },
        { text: 'Sub Kategori', value: 'subsubsubsubcategoryList' },
        { text: 'Deskripsi', value: 'description' },
        { text: 'Tingkat', value: 'level.name' },
        { text: 'Tahun Terbit', value: 'year' },
        { text: 'Penulis', value: 'writer.name' },
        { text: 'Penerbit', value: 'publisher.name' },
        { text: 'Status', value: 'statusLibrary' },
      ],
      filters: [],
      filterQuery: {
        category: '',
        sub_category: '',
        sub_sub_category: '',
        sub_sub_sub_category: '',
        sub_sub_sub_sub_category: '',
        sub_sub_sub_sub_sub_category: '',
        year: '',
        level: '',
        library: '',
      },
      yearFilter: [],
      levelFilter: [],
      formValid: false,
      urlContent: '',
    }
  },
  computed: {
    initialFile: {
      get() {
        if (typeof this.library.thumbnail === 'string') {
          return new File([this.library.thumbnail], this.library.thumbnail, { type: 'text/plain' })
        }

        return this.library.thumbnail
      },
      set() {
        return this.library.thumbnail
      },
    },
  },
  watch: {
    library: {
      handler() {
        const valid = []
        const requiredField = ['name', 'year']
        Object.entries(this.library).forEach(([key, item]) => {
          if (requiredField.includes(key)) {
            if (requiredField.includes(key) && Object.keys(item).length !== 0) {
              valid.push(!!(item && Object.keys(item).length))
            } else {
              valid.push(!!(item && item.length))
            }
          }
        })
        this.formValid = !valid.includes(false)
      },
      deep: true,
    },
    page: {
      handler() {
        this.listLibrary({ ...this.filterQuery })
        // this.insertFiltersOption()
      },
    },
  },
  mounted() {
    this.isLoadingTable = true

    this.listLevel()
    this.listLibrary()
    this.listCategory()
    this.listWriter()
    this.listPublisher()
    this.insertFiltersOption()

    this.isLoadingTable = false
  },
  methods: {
    handleRadio(value) {
      this.radioType = value
    },
    addChapter() {
      this.chapterContent = [
        ...this.chapterContent,
        {
          name: '',
          description: '',
          content: '',
        },
      ]
      this.chapters.push(this.chapterContent)
    },
    resetForm() {
      this.library.name = ''
      this.library.category.uuid = ''
      this.sub_category.uuid = ''
      this.sub_sub_category.uuid = ''
      this.sub_sub_sub_category.uuid = ''
      this.sub_sub_sub_sub_category.uuid = ''
      this.library.description = ''
      this.library.level.uuid = ''
      this.library.writer.uuid = ''
      this.library.publisher.uuid = ''
      this.library.year = ''
      this.radioType = ''
      this.writer.name = ''
      this.library.thumbnail = null
      this.chapters = []
      this.chapterContent = []
    },
    resetCategory() {
      this.library.category.uuid = ''
      this.sub_category.uuid = ''
      this.sub_sub_category.uuid = ''
      this.sub_sub_sub_category.uuid = ''
      this.sub_sub_sub_sub_category.uuid = ''
    },
    showFormAdd() {
      this.dialog = 'add'
      this.multiCategories = []
      this.tempCategory = []
      this.resetForm()
      this.addChapter()
      this.listCategory()
      this.listWriter()
      this.listPublisher()
      this.listLevel()
      this.modalDialog = true
    },
    showFormWriter() {
      this.type = 'writer'
      this.modalDialogWriterAndPublisher = true
    },
    showFormPublisher() {
      this.type = 'publisher'
      this.modalDialogWriterAndPublisher = true
    },
    paginationHandler(pageNumber) {
      this.page = pageNumber
    },
    async listLibrary(params = { ...this.filterQuery }) {
      this.isLoadingData = true
      await this.$services.ApiServices.list(this.service, { ...params, page: this.page, status: 'free' }).then(
        async ({ data }) => {
          this.libraries = await data.data.map((libraries, index) => {
            libraries.subcategory = []
            libraries.subsubcategory = []
            libraries.subsubsubcategory = []
            libraries.subsubsubsubcategory = []
            // libraries.subsubsubsubsubcategory = []
            libraries.category.map((data, key) => {
              let categoryMap = []
              categoryMap.push(
                libraries.category[key].parent_category?.parent_category?.parent_category?.parent_category,
              )
              categoryMap.push(libraries.category[key].parent_category?.parent_category?.parent_category)
              categoryMap.push(libraries.category[key].parent_category?.parent_category)
              categoryMap.push(libraries.category[key].parent_category)
              categoryMap.push(libraries.category[key])
              categoryMap = categoryMap.filter(item => item)
              categoryMap.forEach((item, index) => {
                if (index === 0) libraries.category[key] = item
                else libraries[`${'sub'.repeat(index)}category`].push(item)
              })

              return {
                ...libraries,
                index: index + 1,
              }
            })

            return {
              ...libraries,
              index: index + 1,
              typeLibrary: {
                audio: libraries.audio,
                video: libraries.video,
                ebook: libraries.ebook,
              },
            }
          })

          this.totalItems = data.meta.total
          this.totalPages = data.meta.last_page
        },
        err => {
          console.error(err)
        },
      )
      this.isLoadingData = false
    },
    async getChildCategory(uuid) {
      await this.$services.ApiServices.get('category', uuid).then(
        ({ data }) => {
          let categoryMap = []
          categoryMap.push(data.data?.parent_category?.parent_category?.parent_category?.parent_category)
          categoryMap.push(data.data?.parent_category?.parent_category?.parent_category)
          categoryMap.push(data.data?.parent_category?.parent_category)
          categoryMap.push(data.data?.parent_category)
          categoryMap.push(data.data)
          categoryMap = categoryMap.filter(item => item)
          this.tempCategory.push(categoryMap)
        },
        err => console.error(err),
      )
    },
    async listCategory() {
      await this.$services.ApiServices.list('category', { per_page: 'all', parent: '1' }).then(
        ({ data }) => {
          this.categories = data.data
        },
        err => console.error(err),
      )
    },
    async listLevel() {
      await this.$services.ApiServices.list('level', { per_page: 'all' }).then(
        ({ data }) => {
          this.levels = data.data
        },
        err => console.error(err),
      )
    },
    async listWriter() {
      await this.$services.ApiServices.list('writer', { per_page: 'all' }).then(
        ({ data }) => {
          this.writers = data.data
        },
        err => console.error(err),
      )
    },
    async listPublisher() {
      await this.$services.ApiServices.list('publisher', { per_page: 'all' }).then(
        ({ data }) => {
          this.publishers = data.data
        },
        err => console.error(err),
      )
    },
    listSubCategory() {
      if (this.sub_sub_sub_sub_category.uuid) {
        this.library.category.uuid = this.sub_sub_sub_sub_category.uuid
      } else if (this.sub_sub_sub_category.uuid) {
        this.library.category.uuid = this.sub_sub_sub_category.uuid
      } else if (this.sub_sub_category.uuid) {
        this.library.category.uuid = this.sub_sub_category.uuid
      } else if (this.sub_category.uuid) {
        this.library.category.uuid = this.sub_category.uuid
      }
      if (this.library.category.uuid === '') {
        return this.showSnackbar({
          text: 'category cannot be null',
          color: 'error',
        })
      }
      if (this.multiCategories.includes(this.library.category.uuid)) {
        return this.showSnackbar({
          text: 'cannot add same category',
          color: 'error',
        })
      }
      this.multiCategories.push(this.library.category.uuid)
      // this.multiCategories = this.multiCategories.filter(item => item !== this.library.category.uuid)
      this.getChildCategory(this.library.category.uuid)
      this.resetCategory()

      return true
    },
    showSnackbar(snackbarData) {
      this.$store.dispatch('snackbar/showSnackbar', snackbarData)
    },
    async insertFiltersOption() {
      const categoryFilters = []
      const subcategoryFilters = []
      const subsubcategoryFilters = []
      const subsubsubcategoryFilters = []

      // eslint-disable-next-line no-plusplus
      for (let i = 1990; i <= 2022; i++) {
        this.yearFilter.push(i)
      }

      this.filters = [
        {
          label: 'Category',
          emitName: 'category-filtered',
          data: this.categories,
        },
        {
          label: 'Subcategory',
          emitName: 'subcategory-filtered',
          data: subcategoryFilters,
        },
        {
          label: 'Subsubcategory',
          emitName: 'subsubcategory-filtered',
          data: subsubcategoryFilters,
        },
        {
          label: 'Subsubsubcategory',
          emitName: 'subsubsubcategory-filtered',
          data: subsubsubcategoryFilters,
        },
        {
          label: 'Level',
          emitName: 'level-filtered',
          data: this.levels,
        },
        {
          label: 'Year',
          emitName: 'year-filtered',
          data: this.yearFilter,
        },
      ]
    },
    async handleCategoryFilter(event) {
      this.filterQuery.category = event.uuid
      this.filters = this.filters.filter(
        item => !['Subcategory', 'Subsubcategory', 'Subsubsubcategory', 'Level', 'Year'].includes(item.label),
      )
      this.filters = [
        ...this.filters,
        {
          label: 'Subcategory',
          emitName: 'subcategory-filtered',
          data: event.sub_categories,
        },
        {
          label: 'Subsubcategory',
          emitName: 'subsubcategory-filtered',
          data: [],
        },
        {
          label: 'Subsubsubcategory',
          emitName: 'subsubsubcategory-filtered',
          data: [],
        },
        {
          label: 'Level',
          emitName: 'level-filtered',
          data: this.levelFilter,
        },
        {
          label: 'Year',
          emitName: 'year-filtered',
          data: this.yearFilter,
        },
      ]
      this.listLibrary(this.filterQuery)
    },
    async handleSubcategoryFilter(event) {
      this.filterQuery.category = event.uuid
      this.filters = this.filters.filter(
        item => !['Subsubcategory', 'Subsubsubcategory', 'Level', 'Year'].includes(item.label),
      )
      this.filters = [
        ...this.filters,
        {
          label: 'Subsubcategory',
          emitName: 'subsubcategory-filtered',
          data: event.sub_categories,
        },
        {
          label: 'Subsubsubcategory',
          emitName: 'subsubsubcategory-filtered',
          data: [],
        },
        {
          label: 'Level',
          emitName: 'level-filtered',
          data: this.levelFilter,
        },
        {
          label: 'Year',
          emitName: 'year-filtered',
          data: this.yearFilter,
        },
      ]
      this.listLibrary(this.filterQuery)
    },
    async handleSubsubcategoryFilter(event) {
      this.filterQuery.category = event.uuid
      this.filters = this.filters.filter(item => !['Subsubsubcategory', 'Level', 'Year'].includes(item.label))
      this.filters = [
        ...this.filters,
        {
          label: 'Subsubsubcategory',
          emitName: 'subsubsubcategory-filtered',
          data: event.sub_categories,
        },
        {
          label: 'Level',
          emitName: 'level-filtered',
          data: this.levelFilter,
        },
        {
          label: 'Year',
          emitName: 'year-filtered',
          data: this.yearFilter,
        },
      ]
      this.listLibrary(this.filterQuery)
    },
    async handleSubsubsubcategoryFilter(event) {
      this.filterQuery.category = event.uuid
      this.listLibrary(this.filterQuery)
    },
    async handleYearFilter(event) {
      this.filterQuery.year = event
      this.listLibrary(this.filterQuery)
    },
    async handleLevelFilter(event) {
      this.filterQuery.level = event.uuid
      this.listLibrary(this.filterQuery)
    },
    changeSubcategories() {
      const category = this.categories.filter(item => item.uuid === this.library.category.uuid)
      this.subcategories = category.length > 0 ? [...category[0].sub_categories] : []
      this.sub_category.uuid = ''
      this.subsubcategories = []
    },
    changeSubsubcategories() {
      const subcategory = []
      this.categories.forEach(item => {
        item.sub_categories.forEach(sub => {
          if (sub.uuid === this.sub_category.uuid) subcategory.push(sub)
        })
      })
      this.sub_sub_category.uuid = ''
      this.subsubcategories = subcategory.length > 0 ? [...subcategory[0].sub_categories] : []
    },
    changeSubsubsubcategories() {
      const subcategory = []
      this.subcategories.forEach(item => {
        item.sub_categories.forEach(sub => {
          if (sub.uuid === this.sub_sub_category.uuid) subcategory.push(sub)
        })
      })
      this.sub_sub_sub_category.uuid = ''
      this.subsubsubcategories = subcategory.length > 0 ? [...subcategory[0].sub_categories] : []
    },
    changeSubsubsubsubcategories() {
      const subcategory = []
      this.subsubcategories.forEach(item => {
        item.sub_categories.forEach(sub => {
          if (sub.uuid === this.sub_sub_sub_category.uuid) subcategory.push(sub)
        })
      })
      this.sub_sub_sub_sub_category.uuid = ''
      this.subsubsubsubcategories = subcategory.length > 0 ? [...subcategory[0].sub_categories] : []
    },
    async listCategoryEditSession(cat) {
      await this.listCategory()
      this.categories.forEach(category => {
        this.subcategories = [...this.subcategories, ...category.sub_categories]

        category.sub_categories.forEach(sub => {
          this.subsubcategories = [...this.subsubcategories, ...sub.sub_categories]

          sub.sub_categories.forEach(sub => {
            this.subsubsubcategories = [...this.subsubsubcategories, ...sub.sub_categories]

            sub.sub_categories.forEach(sub => {
              this.subsubsubsubcategories = [...this.subsubsubsubcategories, ...sub.sub_categories]
            })
          })
        })
      })

      cat.map((category, index) => this.multiCategories.push(category.uuid))
    },
    searchHandler(data) {
      this.filterQuery.library = data
      this.page = 1
      this.listLibrary({ ...this.filterQuery })
    },
    resetFilter() {
      this.filterQuery = {
        category: '',
        sub_category: '',
        sub_sub_category: '',
        sub_sub_sub_category: '',
        sub_sub_sub_sub_category: '',
        sub_sub_sub_sub_sub_category: '',
        year: '',
        level: '',
        library: '',
      }
      this.insertFiltersOption()
      this.listLibrary()
    },
  },
}
</script>

<style>
.category-table {
  height: auto;
  max-height: 400px;
  overflow-y: scroll;
  overflow-x: scroll;
}
</style>
